export const TAX_CLS_VIEW = 'TAX_CLS_VIEW';
export const TAX_CLS_VIEW_LOADED = 'TAX_CLS_VIEW_LOADED';
export const TAX_CLS_LIST_ALL = 'TAX_CLS_LIST_ALL';
export const TAX_CLS_LISTED_ALL = 'TAX_CLS_LISTED_ALL';
export const TAX_CLS_UNLOAD = 'TAX_CLS_UNLOAD';
